import { render, staticRenderFns } from "./BreadModelDeleteDialog.vue?vue&type=template&id=329fc3c0&scoped=true&"
import script from "./BreadModelDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./BreadModelDeleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./BreadModelDeleteDialog.vue?vue&type=style&index=0&id=329fc3c0&scoped=true&lang=css&"
import style1 from "./BreadModelDeleteDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329fc3c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
